package com.milta.core.localization.translations.es

import com.milta.core.localization.AdminOcrAnalysisStrings

internal val AdminOcrAnalysis = AdminOcrAnalysisStrings(
    loading = "Cargando…",
    errorNoConnection = "No se puede contactar con el servidor — comprueba tu conexión.",
    errorGeneric = "Se produjo un error. Inténtalo de nuevo más tarde.",
    emptyStateMessage = "Todavía no hay datos.",
    kpiTotalDocumentsLabel = "Documentos analizados",
    kpiCompletedDocumentsLabel = "Documentos completos",
    kpiCompletedDocumentsSubtitle = "simulados en las 4 estrategias",
    kpiTotalRealCostLabel = "Costo real total",
    kpiTotalInputTokensLabel = "Tokens de entrada",
    kpiTotalOutputTokensLabel = "Tokens de salida",
    breakdownByFileKindLabel = "Desglose",
    fileKindImageLabel = "Imágenes",
    fileKindPdfLabel = "PDF",
    fileKindXlsxLabel = "Hojas de cálculo",
    flowTitle = "El flujo completo, paso a paso",
    flowYesLabel = "Sí",
    flowNoLabel = "No",
    flowStep1Title = "Documento enviado",
    flowStep1Subtitle = "Foto, PDF o archivo recibido a través de la app",
    flowStep2Title = "Huella única calculada",
    flowStep2Subtitle = "Se calcula un identificador único para este documento",
    flowStep2Note = "Si ya se vio antes: el análisis local no se repite (el costo real de la IA se sigue contando normalmente, ya que es un envío real).",
    flowStep3Title = "Tipo de archivo detectado",
    flowStep3Subtitle = "El resto del análisis difiere según el tipo",
    flowImageBranchTitle = "📷 Si es una foto",
    flowImageStep1Title = "Comprobación de calidad",
    flowImageStep1Subtitle = "Nitidez, brillo, resolución, documento bien encuadrado",
    flowImageStep2Title = "Si la calidad se considera insuficiente",
    flowImageStep2Subtitle = "El motivo se registra, pero la lectura local se intenta igualmente justo después",
    flowImageStep3Title = "Corrección de inclinación",
    flowImageStep3Subtitle = "La imagen se endereza si se detecta una inclinación fiable",
    flowImageStep4Title = "Lectura local (gratuita)",
    flowImageStep4Subtitle = "Lectura del texto sin IA — francés, neerlandés, inglés",
    flowImageStep5Title = "Puntuación de fiabilidad",
    flowImageStep5Subtitle = "Puntuación de 0 a 100 sobre la calidad de esta lectura local",
    flowPdfBranchTitle = "📄 Si es un PDF",
    flowPdfStep1Title = "¿Texto nativo detectado?",
    flowPdfStep1Subtitle = "Comprueba si el PDF ya contiene texto digital utilizable",
    flowPdfNote = "Si está escaneado sin texto nativo: cada página (máx. 20) se renderiza como imagen y se vuelve a leer localmente, igual que una foto.",
    flowXlsxBranchTitle = "📊 Si es una hoja de cálculo",
    flowXlsxStep1Title = "Columnas identificadas",
    flowXlsxStep1Subtitle = "Reconocimiento automático, o asistido por IA, de las columnas (nombre, dirección, teléfono…)",
    flowXlsxNote = "Estructura del archivo (filas, columnas, encabezado) analizada localmente.",
    flowClaudeTitle = "Llamada a la IA (Claude)",
    flowClaudeSubtitle = "Hoy siempre se realiza una llamada real, sin importar la ruta anterior — costo real facturado",
    flowSimulationTitle = "🔬 Simulación posterior (no en producción)",
    flowSimulationNote = "Una vez recopilados los datos anteriores, se reproducen 4 estrategias alternativas sobre estos mismos documentos para estimar lo que habrían costado en lugar de la llamada sistemática a la IA — eso es exactamente lo que compara la tabla de abajo. Ninguna de estas 4 estrategias se usa realmente en producción hoy.",
    flowPersistTitle = "Guardado",
    flowPersistSubtitle = "El resultado real y las 4 simulaciones se almacenan",
    flowDashboardTitle = "Panel",
    flowDashboardSubtitle = "Esta pantalla agrega los resultados por estrategia",
    tableTitle = "Comparación de estrategias posibles",
    columnMode = "Estrategia",
    columnDocuments = "Documentos",
    columnClaudeCalls = "Llamadas a la IA",
    columnProjectedCost = "Costo proyectado",
    columnRealCost = "Costo real",
    columnSavings = "Ahorro proyectado",
    modeBaseline = "Estrategia actual",
    modeBaselineDescription = "La IA se llama sistemáticamente para cada documento — esto es lo que realmente se usa hoy en producción.",
    modeMinimal = "Preprocesamiento ligero",
    modeMinimalDescription = "Pequeñas optimizaciones antes de enviar a la IA, sin cambiar la decisión: la IA siempre se llama, mismo costo que la estrategia actual.",
    modeTesseractGate = "Lectura local con respaldo de IA",
    modeTesseractGateDescription = "Una lectura local gratuita evalúa primero la calidad del documento; la IA solo se llama si esa lectura se considera insuficiente.",
    modeTesseractOnly = "Solo lectura local",
    modeTesseractOnlyDescription = "Ninguna llamada a la IA — solo una lectura local gratuita, potencialmente menos fiable en documentos de baja calidad.",
)
